export const colors = {
  background: "#fff",
  menu: "#fff"
};
